var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox-wrapper"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":function($event){return _vm.$emit('clicked', $event)}}}),_c('span',{staticClass:"checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }